import React from "react";

const ChatPlaceholder = () => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col items-end mb-4">
        <div className="h-4 w-1/3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-2"></div>
        <div className="h-20 w-2/3 bg-content1 rounded-l-lg rounded-tr-lg animate-pulse"></div>
      </div>

      <div className="flex flex-col items-start mb-4">
        <div className="h-4 w-1/3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-2"></div>
        <div className="h-16 w-2/3 bg-content2 rounded-r-lg rounded-tl-lg animate-pulse"></div>
      </div>
    </div>
  );
};

export default ChatPlaceholder;
